import {
  WS_DAYS,
  WS_ONE_DAY,
  WS_ONE_WEEK,
  WS_SHIFTS,
  WS_WEEKS,
} from '@pages/WorkSchedule/constants/filters';

import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

import type { RadioChangeEvent } from 'antd';

export const handlePeriodChange = (
  event: RadioChangeEvent,
  staticFilters: React.MutableRefObject<NWorkSchedule.Filters>,
  setDynamicFilters: (data: NWorkSchedule.Filters) => void,
  setFilterByDays: (value: boolean) => void
) => {
  const value = event.target.value || null;

  const createNewFilter = (
    detailedPeriod: NWorkSchedule.Filters['period']['detailedPeriod']
  ) => ({
    period: {
      primaryPeriod: value,
      detailedPeriod,
    },
  });

  setFilterByDays(false);

  if (staticFilters) {
    const newData = {
      period: {
        ...staticFilters.current.period,
        main: value,
      },
    };

    staticFilters.current = newData;
    setDynamicFilters(newData);
  }

  if (value === WS_DAYS) {
    setFilterByDays(true);

    if (staticFilters) {
      const newData = createNewFilter(WS_ONE_DAY);
      staticFilters.current = newData;
      setDynamicFilters(newData);
    }
  } else if (value === WS_SHIFTS || value === WS_WEEKS) {
    if (staticFilters) {
      // Здесь устанавливается только значение по умолчанию (выборка),
      // поэтому значение в createNewFilter НЕ равно WS_WEEKS
      // при сценарии value === WS_WEEKS
      const newData = createNewFilter(WS_ONE_WEEK);
      staticFilters.current = newData;
      setDynamicFilters(newData);
    }
  }
};
